import React from "react";
import { saveAs } from "file-saver";
import { toBlob } from "html-to-image";
import { useSelector } from "react-redux";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function RecPromotedPreview({preview}) {
  console.log(preview)
    const componentId = useSelector((state) => state.Head.component_id);
    
    const handleDownloadPreview = () => {
      const previewElement = document.querySelector(".download-preview");
      toBlob(previewElement).then(function (blob) {
        saveAs(blob, `${preview.name}.png`);
      });
    };

    // Sample data for demonstration - in real app this would come from props or API
    const sampleAdCreative = {
      appName: "Blinkit",
      tagline: "India's Last-Minute App",
      icon: "https://via.placeholder.com/60x60/FFD700/000000?text=blinkit",
      buttonText: "Install"
    };

    const sampleNews = [
      {
        id: 1,
        image: "https://d1uy1wopdv0whp.cloudfront.net/newsimages/news_72025/1753944343642_893-normal-WIFI.webp",
        title: "జోకర్ ను ఎన్నుకుంటే పాలన సర్కసే: KTR",
        type: "టాప్ కామెంటెడ్ స్టోరీ",
        icon: "💬"
      },
      {
        id: 3,
        image: "https://d1uy1wopdv0whp.cloudfront.net/newsimages/news_82025/1755760231165_1226-normal-WIFI.webp",
        title: "పాఠ్య పుస్తకాల్లో ఆపరేషన్ సిందూర్",
        type: "మోస్ట్ లైక్ స్టోరీ",
        icon: "👍"
      }
    ];

    return (
      <>
        <div className="flex mb-5">
          {componentId === 6 ? (
            <div className="justify-end">
              <sl-icon-button
                library="lucide"
                name="download"
                onClick={handleDownloadPreview}
              ></sl-icon-button>
            </div>
          ) : null}
        </div>
        <div className="download-preview">
          <CreativeNameDisplay preview={preview} />
          <div className="preview-inner !bg-black !p-12 !rounded-[46px]">
            
            {/* Ad Creative Section - Top */}
            <div className="bg-gray-800 rounded-lg p-4 mb-2 relative !h-[40%]">
              {/* Info and Menu Icons */}
              <div className="flex justify-end gap-2 mb-3">
                <div className="w-6 h-6 bg-gray-500 rounded-full flex items-center justify-center text-white text-sm">i</div>
                <div className="w-6 h-6 flex flex-col justify-center items-center gap-1">
                  <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                  <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                  <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                </div>
              </div>
              
              {/* App Preview Box */}
              <div className="bg-white rounded-lg p-3 mb-4">
                <div className="flex gap-3">
                  {/* Left side - Desktop interface with tables */}
                  <div className="flex-1">
                    <div className="space-y-2">
                      {/* Table rows */}
                      <div className="h-2 bg-gray-200 rounded"></div>
                      <div className="h-2 bg-gray-200 rounded w-4/5"></div>
                      <div className="h-2 bg-gray-200 rounded w-2/3"></div>
                    </div>
                  </div>
                  
                  {/* Right side - Mobile phone outline */}
                  <div className="w-8 h-12 border-2 border-gray-300 rounded-lg flex items-center justify-center">
                    <div className="w-4 h-6 bg-gray-100 rounded-sm"></div>
                  </div>
                </div>
              </div>
              
              {/* App Name and Tagline */}
              <div className="text-center mb-4">
                <h3 className="text-white text-xl font-bold mb-1">{sampleAdCreative.appName}</h3>
                <p className="text-gray-300 text-sm">{sampleAdCreative.tagline}</p>
              </div>
              
            </div>

            {/* Recommended News Section */}
            <div className="flex flex-col justify-between !h-[60%]">
                <div className="mb-1">
              <h2 className="text-white text-xs text-center font-semibold mb-3">Recommended News</h2>
                {preview.img_urls && <div key={'ad'} className="bg-gray-500 rounded-lg px-2 py-2 flex items-center mb-1 gap-3">
                    {/* Placeholder icon - light gray mountain landscape style */}
                    <div className="w-20 bg-gray-400 rounded-lg flex items-center justify-center">
                        <img src={preview.img_urls} alt="news_image" />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-white text-[12px] font-medium leading-4 mb-1">{preview.title || preview.head_line}</h3>
                         {preview.button_enabled ? <div className="w-full d-flex justify-center">
                        <button style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr }} className={`rounded text-xs px-3 py-1`}>{preview.button_text}</button>
                        </div> : null}
                    </div>
                    </div>}
              {sampleNews.map((news, index) => (
                <div key={news.id} className="bg-gray-500 rounded-lg px-2 py-2 flex items-center mb-1 gap-3">
                  {/* Placeholder icon - light gray mountain landscape style */}
                  <div className="w-20 bg-gray-400 rounded-lg flex items-center justify-center">
                    <img src={news.image} alt="news_image" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white text-[12px] font-medium leading-4 mb-1">{news.title}</h3>
                    <div className="flex items-center text-2xs gap-2">
                      <span className="">{news.icon}</span>
                      <span className="text-gray-400">{news.type}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Skip Button */}
            <div className="flex justify-center">
              <div className="bg-gray-700 text-gray-300 px-4 py-1 rounded-full flex items-center gap-1">
                <span className="text-2xs">↑</span>
                <span className="text-2xs">FLIP UP TO SKIP</span>
              </div>
            </div>
            </div>
           
          </div>
        </div>
      </>
    );
  }  

export default RecPromotedPreview;